import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError, tap, switchMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityDepositosLoadRequest,
  entityDepositosLoadFailure,
  entityDepositosLoadSuccess,
  entityDepositosAddFailure,
  entityDepositosAddRequest,
  entityDepositosAddSuccess,
  entityDepositosDeleteRequest,
  entityDepositosDeleteSuccess,
  entityDepositosDeleteFailure
} from './depositos.actions';
import { selectDepositosState } from './depositos.selectors';
import { DepositosService } from './depositos.service';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class DepositosEffects {
  // load
  loadRequestDepositos = createEffect(() =>
    this.actions$.pipe(
      ofType(entityDepositosLoadRequest),
      mergeMap(() =>
        this.depositosService.getDepositos().pipe(
          map((items) => entityDepositosLoadSuccess({ items })),
          catchError((error) => of(entityDepositosLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestDeposito = createEffect(() =>
    this.actions$.pipe(
      ofType(entityDepositosAddRequest),
      switchMap((action) =>
        this.depositosService.addDepositos(action.item).pipe(
          map((item) => entityDepositosAddSuccess({ item: item })),
          catchError((error) => of(entityDepositosAddFailure({ error })))
        )
      )
    )
  );

  addSuccessDeposito = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityDepositosAddSuccess),
        switchMap(() => of(entityDepositosLoadRequest()))
      ),
    { dispatch: false }
  );

  deleteRequestDeposito = createEffect(() =>
    this.actions$.pipe(
      ofType(entityDepositosDeleteRequest),
      mergeMap((action) =>
        this.depositosService.deleteDepositos(action.item).pipe(
          map((item) => {
            this.alertService.success('Depósito eliminado correctamente.');
            return entityDepositosDeleteSuccess({ item: action.item });
          }),
          catchError((error) => of(entityDepositosDeleteFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private depositosService: DepositosService,
    private router: Router,
    private alertService: NotificationService
  ) {
    this.depositosService.url = environment.apiUrl;
  }
}
